import { getTrackingPageBlockDefinitions } from '@reveni-io/reveni-ui'

import services from '../services/services'

const handleShipmentClick = shippingLabel => {
  window.open(`/labels/${shippingLabel.id}`, '_blank', 'noopener,noreferrer')
}

const getRecommendedProducts = ({ orderId, page = 1, maxProducts, productSource, productSourceValue }) => {
  const params = {
    page,
    max_products: maxProducts,
    product_source: productSource,
    product_source_value: productSourceValue,
  }

  return services.getRecommendedProducts({ orderId, params })
}

export const blockDefinitions = getTrackingPageBlockDefinitions({
  onShipmentClick: handleShipmentClick,
  getRecommendedProductsService: getRecommendedProducts,
})
